import HttpRequest from '@/config/axios.config'
import { get, isEmpty, omit } from 'lodash'
import moment from 'moment'

export async function createProductionStatus(id: string, payload: any) {
  const start_date = moment(payload[0], 'YYYY-MM-DD').format('YYYY-MM-DD')
  const end_date = moment(payload[1], 'YYYY-MM-DD').format('YYYY-MM-DD')

  return await HttpRequest.post(`/orders/${id}/production-status`, {
    start_date,
    end_date,
  }).catch((error) => error.response.data.message)
}

const transformReportPayload = (payload) =>
  payload.map((elem) => {
    const {
      day,
      planned_lines,
      planned_pieces_per_line,
      planned_total,
      actual_lines,
      actual_pieces_per_line,
      actual_total,
      packed_total,
    } = elem
    return {
      day,
      planned_lines,
      planned_pieces_per_line,
      planned_total,
      actual_lines,
      actual_pieces_per_line,
      actual_total,
      packed_total,
    }
  })

export const createUpdateProductionStatusReport = async (
  id: string,
  payload: any
) => {
  const wrapPayload = {
    data: transformReportPayload(payload),
  }

  const result = await HttpRequest.post(
    `/production-statuses/${id}/reports`,
    wrapPayload
  ).catch((error) => error?.response)
  if (String(result?.data?.statusCode).includes('20')) {
    return result
  }
  return null
}

export async function getProductionStatusReport(
  id: string,
  tableDataHeader = []
) {
  if (!isEmpty(tableDataHeader)) {
    const headerLength = tableDataHeader.length
    const startDate = get(tableDataHeader[0], 'dataIndex')
    const endDate = get(tableDataHeader[headerLength - 1], 'dataIndex')
    const result = await HttpRequest.get(
      `/production-statuses/${id}/reports/${startDate}/${endDate}`
    ).catch((error) => error.response.data.message)

    if (String(result?.data?.statusCode).includes('20')) {
      const { data } = result.data
      return data
    } else {
      return []
    }
  }
  return []
}
